/**
 * Device Fingerprint Utility
 * Generates a persistent fingerprint cookie for tracking device identity
 * across IP changes (VPN detection). Uses localStorage + cookie for persistence.
 */

const FP_KEY = 'nls_device_fp';
const FP_COOKIE = 'nls_device_fp';

function generateFingerprint() {
  const nav = window.navigator;
  const screen = window.screen;
  const raw = [
    nav.userAgent,
    nav.language,
    screen.width + 'x' + screen.height,
    screen.colorDepth,
    new Date().getTimezoneOffset(),
    nav.hardwareConcurrency || 'unknown',
    nav.maxTouchPoints || 0,
    Math.random().toString(36).substring(2, 10),
    Date.now().toString(36)
  ].join('|');

  // Simple hash
  let hash = 0;
  for (let i = 0; i < raw.length; i++) {
    const char = raw.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash).toString(36) + Date.now().toString(36);
}

function setCookie(name, value, days = 365) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value};expires=${expires};path=/;SameSite=Lax`;
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

export function getDeviceFingerprint() {
  // Check localStorage first
  let fp = localStorage.getItem(FP_KEY);
  if (fp) {
    // Ensure cookie is also set
    setCookie(FP_COOKIE, fp);
    return fp;
  }

  // Check cookie (survives localStorage clears)
  fp = getCookie(FP_COOKIE);
  if (fp) {
    localStorage.setItem(FP_KEY, fp);
    return fp;
  }

  // Generate new fingerprint
  fp = generateFingerprint();
  localStorage.setItem(FP_KEY, fp);
  setCookie(FP_COOKIE, fp);
  return fp;
}

// Initialize fingerprint on import
getDeviceFingerprint();
